'use strict';
/**
 * @author Maxim Seredkin
 */


export default function () {
    return {
        restrict: 'A',
        template: require('../view/custom-select.html'),
        transclude: true,
        scope: {
            options: '=options',
            selectedModel: '=selectedModel',
            operatorTranslate: '=operatorTranslate',
            defaultText: "=defaultText"
        },
        controller: ['$scope', '$rootScope',
            function ($scope, $rootScope) {

                $scope.current = currentOption();
                $scope.calculatePosition = (event) => {
                    const target = event.currentTarget;
                    if (!target) return;
                    const popup = target.nextSibling.nextSibling;
                    const clientRect = target.getBoundingClientRect();
                    if (!popup) return;
                    const windowHeight = window.innerHeight;
                    if ((clientRect.bottom + 50 + 200) >= windowHeight) {
                        popup.classList.add('dropdown-custom__menu--bottom');
                    } else {
                        popup.classList.remove('dropdown-custom__menu--bottom');
                    };
                };

                function currentOption() {
                    if ($scope.operatorTranslate) {
                        return $scope.operatorTranslate($scope.selectedModel);
                    } else {
                        if (!$scope.options || !$scope.selectedModel) return $scope.defaultText;
                        const option = $scope.options.find(item => item.id === $scope.selectedModel.id);
                        return option ? option.name : $scope.defaultText;
                    }
                };

                $scope.selectOption = (option) => {
                    $scope.selectedModel = angular.copy(option);
                }

                $scope.$watch('selectedModel', () => $scope.current = currentOption())
                
            }]
    };
}
